import { api } from "../config/api";

export const getFreelancerHistory = async () => {
  const response = await api.get(`/Favorites/history`);
  return response.data;
};

export const getFavorites = async () => {
  const response = await api.get(`/Favorites`);
  return response.data;
};

export const addFavorite = async (freelancerId) => {
  const response = await api.post(`/Favorites/${freelancerId}`);
  return response.data;
};

export const removeFavorite = async (freelancerId) => {
  await api.delete(`/Favorites/${freelancerId}`);
};